import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function ColorIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.586 0L0 6.586V9.414L9.414 0H6.586Z" />
        <path d="M0 0V3.414L3.414 0H0Z" />
        <path d="M10.586 14H14V10.586L10.586 14Z" />
        <path d="M14 0H12.586L0 12.586V14H1.414L14 1.414V0Z" />
        <path d="M14 4.586L4.586 14H7.414L14 7.414V4.586Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10ZM7 12C9.76142 12 12 9.76142 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12Z"
        />
      </svg>
    </Icon>
  );
}
